import { instance as axios } from '@/api/baseUrl';
import type { ProfileResponse, ProfileUpdateData } from '../types';

export const getProfile = () =>
  axios.get<ProfileResponse>('/profile');

export const updateProfile = (data: ProfileUpdateData) =>
  axios.put<ProfileResponse>('/profile', data);
